import { render } from "./HowItWorks1Icon.vue?vue&type=template&id=7218b7d6"
import script from "./HowItWorks1Icon.vue?vue&type=script&lang=js"
export * from "./HowItWorks1Icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__